var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{attrs:{"is-authenticate":_vm.meta.isAuthenticate,"has-navigation":_vm.meta.isNavigation}},[_c('div',{staticClass:"main-container",class:{'main-container--scroll': _vm.isClassroomDetailPage}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }